export function screen(state = {}, action) {
    switch (action.type) {
        case 'FETCH_DISPLAY_SUCCESS':
            return action.screen;
        default:
            return state;
    }
}

export function active_module(state = {}, action) {
    switch (action.type) {
        case 'SWITCH_MODULE_SUCCESS':
            return action.active_module;
        default:
            return state;
    }
}

export function options(state = {}, action) {
    switch (action.type) {
        case 'SET_OPTIONS_SUCCESS':
            return action.options;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/display.js